// Matches text made up entirely of bracketed tags: 
// "[groan]", "[sighs]", "[groan][sigh]".
//
// ElevenLabs parses and removes tags during audio generation, 
// so tag-only input has nothing left to synthesize 
// and returns HTTP 400 (`input_text_empty`). 
// 
// Padding the text to make it speakable is undocumented 
// and inconsistent across tag/voice/token combinations — 
// measured 2026-08-14, one pad produced audio for one pair 
// and an empty body the Sim cannot decode for another. 
// Callers serve silence instead.
//
// Pattern notes:
//   (?:...)+     repeated tags match, not just a single tag
//   [^[\]]*      no nested brackets, so "[[groan]]" does not match
//   \s*          surrounding whitespace allowed, and not trimmed: callers hash this
//                text, so normalizing here would re-key existing objects
const TAG_ONLY = /^(?:\s*\[[^[\]]*\])+\s*$/;

// express.text() leaves req.body as {} on a content-type mismatch, so non-strings
// reach this on real request paths.
function isTagOnlyText(text) {
  return typeof text === 'string' && TAG_ONLY.test(text);
}

module.exports = isTagOnlyText;
